(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["luma-email-popup"] && !Shopify.designMode) return;
  try {
    
  class LumaEmailPopup extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.dialog = this.querySelector('dialog');
      if (!this.dialog) return;

      this.storageKey = 'luma-email-popup-suppressed-until';
      this.delay = Number(this.dataset.delay || 1800);
      this.dismissDays = Number(this.dataset.dismissDays || 7);
      this.hasSuccess = Boolean(this.querySelector('[data-luma-popup-success]'));
      this.hasError = Boolean(this.querySelector('[data-luma-popup-error]'));

      this.querySelectorAll('[data-luma-popup-close]').forEach((button) => {
        button.addEventListener('click', () => this.dismiss());
      });

      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.dismiss();
      });

      this.dialog.addEventListener('cancel', (event) => {
        event.preventDefault();
        this.dismiss();
      });

      const copyButton = this.querySelector('[data-luma-popup-copy]');
      if (copyButton) {
        copyButton.addEventListener('click', () => this.copyCode(copyButton));
      }

      if (this.hasSuccess) {
        this.suppress(365);
        this.open();
        return;
      }

      if (this.hasError) {
        this.open();
        return;
      }

      const suppressedUntil = Number(localStorage.getItem(this.storageKey) || 0);
      if (Date.now() >= suppressedUntil) {
        window.setTimeout(() => this.open(), this.delay);
      }
    }

    open() {
      if (!this.dialog.open) this.dialog.showModal();
    }

    dismiss() {
      this.suppress(this.dismissDays);
      this.dialog.close();
    }

    suppress(days) {
      const until = Date.now() + days * 24 * 60 * 60 * 1000;
      localStorage.setItem(this.storageKey, String(until));
    }

    async copyCode(button) {
      const code = this.querySelector('[data-luma-popup-code]')?.textContent.trim();
      if (!code) return;

      try {
        await navigator.clipboard.writeText(code);
        button.textContent = button.dataset.copiedLabel;
        window.setTimeout(() => {
          button.textContent = button.dataset.copyLabel;
        }, 1800);
      } catch {
        const range = document.createRange();
        const codeElement = this.querySelector('[data-luma-popup-code]');
        range.selectNodeContents(codeElement);
        const selection = window.getSelection();
        selection.removeAllRanges();
        selection.addRange(range);
      }
    }
  }

  if (!customElements.get('luma-email-popup')) {
    customElements.define('luma-email-popup', LumaEmailPopup);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
